import React from 'react';

import './style.css';

const PageHeader = ({children}) => <div className="page-header">
  { children }
</div>

export default PageHeader;
